import { useContext, useEffect, useRef, useState } from "react";
import { getHouseMainCarousel } from "./house-service";
import { Carousel, CarouselItems, CarouselMedia } from "./types";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/a11y";
import { HouseCompetitionData } from "./contextProvider";
import Skeleton from "react-loading-skeleton";
import { A11y, Navigation } from "swiper/modules";

const MainCarousel = () => {
  const [carousel, setCarousel] = useState<Carousel[]>();
  const [swiperData, setSwiperData] = useState<CarouselMedia[]>([]);
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const [activeSlideIndex, setActiveSlideIndex] = useState(0);
  const swiperRef = useRef(null);
  const [isLoading, setIsLoading] = useState(true);
  const { prizeId } = useContext(HouseCompetitionData);
  useEffect(() => {
    if (prizeId) {
      getMainCarousel();
    }
  }, [prizeId]);
  const onTabClick = (item: Carousel, tabIndex: number) => {
    setSwiperData(item.Media);
    setActiveTabIndex(tabIndex);
    setActiveSlideIndex(0);
    // Reset Swiper slide index to 0
    if (swiperRef.current) {
      swiperRef.current.slideTo(0); // Resets Swiper to first slide
    }
  };

  const getMainCarousel = async () => {
    try {
      const response = await getHouseMainCarousel(prizeId);
      const { Items } = (await response.json()) as CarouselItems;
      setCarousel(Items);
      setSwiperData(Items[0].Media);
    } catch (err) {
      console.log(`Error while fetching the carousel data - ${JSON.stringify(err)}`);
    } finally {
      setIsLoading(false);
    }
  };

  return isLoading ? (
    <Skeleton inline highlightColor="#fff" height={300} containerClassName="h-[300px] w-full bg-[#f1f1f1]" />
  ) : (
    <div className="flex flex-col">
      <div className={`w-full relative carousel-container-within-slide-navigation`}>
        <Swiper
          modules={[Navigation, A11y]}
          slidesPerView={1}
          loop={false}
          spaceBetween={0}
          navigation
          onSlideChangeTransitionEnd={swiper => {
            setActiveSlideIndex(swiper.realIndex);
          }}
          onSwiper={swiper => (swiperRef.current = swiper)}
          className="w-full"
          style={{
            zIndex: 0,
          }}>
          {swiperData.map((mediaItem, index) => (
            <SwiperSlide key={index} style={{ height: "auto" }}>
              <div className="w-full h-full flex overflow-hidden relative">
                {!mediaItem.IsVideo ? (
                  <img src={mediaItem.Url} alt={`slide-${index}`} className="w-full" loading="lazy" />
                ) : (
                  <video src={mediaItem.Url} autoPlay loop muted playsInline />
                )}
                {swiperData.length > 1 && (
                  <span className="absolute bottom-5 left-10 bg-[#00000080] rounded text-white px-1">
                    {activeSlideIndex + 1}/{swiperData.length}
                  </span>
                )}
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      <div className="flex justify-around items-center bg-[#F1F1F1] overflow-auto whitespace-nowrap">
        {carousel?.map((item, index) => (
          <div
            key={index}
            className={`font-jost text-[16px] font-normal p-3 cursor-pointer ${activeTabIndex === index ? "border-t-2 border-solid border-t-[#FF8200]" : ""}`}
            onClick={() => onTabClick(item, index)}>
            {item.Name}
          </div>
        ))}
      </div>
    </div>
  );
};

export default MainCarousel;
